module.exports = __webpack_public_path__ + "img/shadowpng.11b77e24.png";